import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import axios from "axios";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  RemoveSession,
  stringifyData,
} from "../utils/page";
import CustomOrderComponent from "../../Components/CustomOrders/CustomOrderComponent";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CustomerOrders = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState("");
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [loginTokenda, setLoginTokenda] = useState(FetchToken || null);
  const [orderDetails, setOrderDetails] = useState("");
  const [biddingDetails, setBiddingDetails] = useState("");
  const [cancelStatus, setCancelStatus] = useState();
  const[trackingAlreadyData,setTrackingAlreadyData]=useState();

  const orderDetailsArray = Array.isArray(orderDetails) ? orderDetails : [];
  const [activeButton, setActiveButton] = useState("order");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [shippingBy, setShippingBy] = useState("");
  const [trackingNo, setTrackingNo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [showShipModal, setShowShipModal] = useState(false);
  const [shippingStatusModal, setShippingStatusModal] = useState(false);
  const [prefiledData, setPrefiledData] = useState(null);
  const [productClickDetail, setProductClickDetail] = useState();
  const [trackingDetailModal,setTrackingDetailModal]=useState(false)
  const handleCloseTrackingModal=()=>{
    setTrackingDetailModal(false)
    setEditShipping(false);

  }

  const [trackingData, setTrackingData] = useState({
    item: "",
    obj: "",
  });

  const [editShipping, setEditShipping] = useState(false);

  const [viewDetails, setViewDetails] = useState(
    orderDetailsArray.map(() => false)
  );
  const [prefiledShipData, setPrefiledShipData] = useState();
  const [deliverStatusForm, setDeliveryStatusForm] = useState({
    DeliveryEstimatedTime: "",
    ShippingBy: "",
    PhoneNumber: "",
    TrackingNumber: "",
    Status: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    DeliveryEstimatedTime: "",
    ShippingBy: "",
    PhoneNumber: "",
    TrackingNumber: "",
    Status: "",
  });
  const [productTrackingForm, setProductTrackingForm] = useState({
    DeliveryEstimatedTime: "",
    ShippingBy: "",
    PhoneNumber: "",
    TrackingNumber: "",
    Status: "",
  });

  const [errorMessageTracking, setErrorMessageTracking] = useState({
    DeliveryEstimatedTime: "",
    ShippingBy: "",
    PhoneNumber: "",
    TrackingNumber: "",
    Status: "",
  });

  const handleGetOrderDetails = (item) => {
    if (item !== "allStatus") {
      setLoading("order");
    }
    const data = {
      pageNumber: 1,
      pageSize: 10,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Vendor/OrderOverview`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setOrderDetails(data);
        setLoading("");
        if (item == "allStatus") {
          const filter = data?.find(
            (io) =>
              io?.OrderSummary?.OrderNumber ==
              prefiledData?.OrderSummary?.OrderNumber
          );
          if (
            filter?.ProductDetail?.every(
              (product) => product.Status === "Delivered"
            )
          ) {
            handleOverAllStatus("Delivered");
          } else if (
            filter?.ProductDetail?.every(
              (product) => product.Status === "Cancel"
            )
          ) {
            handleOverAllStatus("Cancel");
          } else if (
            filter?.ProductDetail?.every(
              (product) => product.Status === "OutForDelivery"
            )
          ) {
            handleOverAllStatus("OutForDelivery");
          }
        }
      })
      .catch((error) => {
        //  if (error?.code === "ERR_BAD_REQUEST") {
        //           RemoveSession(navigate);
        //         }
      });
  };
  useEffect(() => {
    handleGetOrderDetails();
  }, []);

  const GetBiddingDetails = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Vendor/GetWinnersAndInfoForVendor`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        const sortedData = data?.sort((a, b) => a.Position - b.Position);
        setBiddingDetails(sortedData);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (loginToken) {
      GetBiddingDetails();
    }
  }, [loginToken]);

  const handleOpenModal = (data) => {
    setShowModal(true);
    setPrefiledData(data);
    setDeliveryTime(data?.deliveryTime || "");
    setShippingBy(data?.shippingBy || "");
    setTrackingNo(data?.trackingNo || "");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setPrefiledData(null);
    setDeliveryTime("");
    setShippingBy("");
    setTrackingNo("");
  };

  const handleOpenShipModal = (data) => {
    handleOpenShipStatus(data, "ShippingDetail");
    setPrefiledShipData(data);
  };

  const handleCloseShipModal = () => {
    setShowShipModal(false);
    setEditShipping(false);

    // setPrefiledData(null);
  };

  const handleOpenCancelOrderModal = (data) => {
    setPrefiledData(data);
    setCancelOrderModal(true);
  };
  const handleOpenShipStatus = (pro,i) => {
    // setShippingStatusModal(true);
    const data = {
      OrderId: pro?.OrderSummary?.OrderNumber,
      ProductId:null
      
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/GetShippingDetail`,
    };
    axios(option)
      .then((e) => {
        const data = {
          ...parseData(e?.data?.result),
          productName: pro?.ProductDetail?.[0]?.Name,
        };
        if (!parseData(e?.data?.result)) {
          setShowShipModal(true);
        } else {
          setShippingStatusModal(true);
        }
        setPrefiledData(data);
        setDeliveryStatusForm({
          ...deliverStatusForm,
          DeliveryEstimatedTime: data?.DeliveryEstimatedTime,
          ShippingBy: data?.ShippingBy,
          PhoneNumber: data?.PhoneNumber,
          TrackingNumber: data?.TrackingNumber,
          Status: data?.Status,
        });
      })
      .catch((error) => {});
  };
  const handleCheckShipping = (pro,i) => {
    // setShippingStatusModal(true);
    const data = {
      OrderId: pro?.OrderSummary?.OrderNumber,
      ProductId:i?.ProductId

    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/GetShippingDetail`,
    };
    axios(option)
      .then((e) => {
        const data = {
          ...parseData(e?.data?.result),
          productName: pro?.ProductDetail?.[0]?.Name,
        };
       setTrackingAlreadyData(data);
        // setPrefiledData(data);
        setProductTrackingForm({
          ...productTrackingForm,
          DeliveryEstimatedTime: data?.DeliveryEstimatedTime,
          ShippingBy: data?.ShippingBy,
          PhoneNumber: data?.PhoneNumber,
          TrackingNumber: data?.TrackingNumber,
          Status: data?.Status,
        });
      })
      .catch((error) => {});
  };
  const handleCloseCancelOrderModal = () => {
    setCancelOrderModal(false);
  };
  const handleShipStatusModal = () => {
    setShippingStatusModal(false);
  };

  const handleAddAddress = () => {
    const data = {
      Id: prefiledData?.Id,
      DeliveryEstimatedTime: deliverStatusForm?.DeliveryEstimatedTime,
      ShippingBy: deliverStatusForm?.ShippingBy,
      PhoneNumber: deliverStatusForm?.PhoneNumber,
      TrackingNumber: deliverStatusForm?.TrackingNumber,
      OrderId: prefiledShipData?.OrderSummary?.OrderNumber,
      InvoiceNumber: prefiledShipData?.OrderSummary?.InvoiceNumber,
      ProductId:null
      // Status:prefiledShipData?.Status
    };
    // return
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/AddUpdateShippingDetail`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setDeliveryStatusForm({
          DeliveryEstimatedTime: "",
          ShippingBy: "",
          PhoneNumber: "",
          TrackingNumber: "",
          Status: "",
        });

        handleGetOrderDetails();
        handleCloseShipModal();
        handleShipStatusModal();
      })
      .catch((error) => {});

    // handleCloseModal();
  };
  const handleAddTrackingAddres = () => {
    const data = {
      Id: trackingAlreadyData?.Id || null,
      ProductId: trackingData?.item?.ProductId,

      DeliveryEstimatedTime: productTrackingForm?.DeliveryEstimatedTime,
      ShippingBy: productTrackingForm?.ShippingBy,
      PhoneNumber: productTrackingForm?.PhoneNumber,
      TrackingNumber: productTrackingForm?.TrackingNumber,
      OrderId:trackingData?.obj?.OrderSummary?.OrderNumber,
      InvoiceNumber:trackingData?.obj?.OrderSummary?.InvoiceNumber,
      // Status:prefiledShipData?.Status
    };
    // return
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/AddUpdateShippingDetail`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setProductTrackingForm({
          DeliveryEstimatedTime: "",
          ShippingBy: "",
          PhoneNumber: "",
          TrackingNumber: "",
          Status: "",
        });

        handleGetOrderDetails();
        handleCloseTrackingModal();
        
      })
      .catch((error) => {});

    // handleCloseModal();
  };
  const handleStatusUpdate = (e, item) => {
    const data = {
      ProductId: null,
      Status: item == "Delivered" ? "Delivered" : deliverStatusForm?.Status,
      OrderId:
        prefiledShipData?.OrderSummary?.OrderNumber ||
        e?.OrderSummary?.OrderNumber,
      InvoiceNumber:
        prefiledShipData?.OrderSummary?.InvoiceNumber ||
        e?.OrderSummary?.InvoiceNumber,
    };
    // return
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Vendor/UpdateOrderStatus`,
    };
    axios(option)
      .then((e) => {
        setDeliveryStatusForm({
          DeliveryEstimatedTime: "",
          ShippingBy: "",
          PhoneNumber: "",
          TrackingNumber: "",
          Status: "",
        });

        handleGetOrderDetails();
        handleCloseShipModal();
        handleShipStatusModal();
      })
      .catch((error) => {});

    // handleCloseModal();
  };
  const handleTrackingStatusUpdate = (e, item) => {
    const data = {
      ProductId: trackingData?.item?.ProductId,
      Status:"In Progress",
      OrderId:
      trackingData?.obj?.OrderSummary?.OrderNumber ,
      InvoiceNumber:
      trackingData?.obj?.OrderSummary?.InvoiceNumber 
    };
    // return
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Vendor/UpdateOrderStatus`,
    };
    axios(option)
      .then((e) => {
        setProductTrackingForm({
          DeliveryEstimatedTime: "",
          ShippingBy: "",
          PhoneNumber: "",
          TrackingNumber: "",
          Status: "",
        });

        handleGetOrderDetails();
        handleCloseTrackingModal();
      })
      .catch((error) => {});

    // handleCloseModal();
  };

  const handleConfirmDelivery = () => {
    const data = [
      {
        ProductId:
          cancelStatus?.trim() === "OutForDelivery" ||
          cancelStatus?.trim() === "Delivered" ||
          cancelStatus?.trim() === "Cancel"
            ? productClickDetail?.ProductId
            : null,
        Status:
          cancelStatus?.trim() == "OutForDelivery"
            ? "OutForDelivery"
            : cancelStatus?.trim() == "Delivered"
            ? "Delivered"
            : cancelStatus?.trim() == "Cancel"
            ? "Cancel"
            : null,
        OrderId: prefiledData?.OrderSummary?.OrderNumber,
        InvoiceNumber: prefiledData?.OrderSummary?.InvoiceNumber,
      },
    ];
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      // url: `${Apiurl()}/api/Vendor/UpdateOrderStatus`,
      url: `${Apiurl()}/api/Vendor/UpdateMultipleOrderStatus`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        handleGetOrderDetails("allStatus");
        handleCloseCancelOrderModal();
        handleCloseShipModal();
        handleShipStatusModal();
      })
      .catch((error) => {});

    // handleCloseModal();
  };
  const handleViewDetails = (index) => {
    setViewDetails((prevState) => {
      const updatedState = [...prevState];
      updatedState[index] = !updatedState[index];
      return updatedState;
    });
  };

  const handleOverAllStatus = (e, item) => {
    const data = {
      ProductId: null,
      Status:
        e == "Delivered"
          ? "Delivered"
          : e == "Cancel"
          ? "Cancel"
          : e == "OutForDelivery"
          ? "OutForDelivery"
          : null,
      OrderId: prefiledData?.OrderSummary?.OrderNumber,
      InvoiceNumber: prefiledData?.OrderSummary?.InvoiceNumber,
    };
    // return
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Vendor/UpdateOrderStatus`,
    };
    axios(option)
      .then((e) => {
        setDeliveryStatusForm({
          DeliveryEstimatedTime: "",
          ShippingBy: "",
          PhoneNumber: "",
          TrackingNumber: "",
          Status: "",
        });

        handleGetOrderDetails();
        // handleCloseShipModal();
        // handleShipStatusModal();
      })
      .catch((error) => {});

    // handleCloseModal();
  };

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header
        setLoading={setLoading}
        loading={loading}
        setLoginToken={setLoginToken}
      />
      <CustomOrderComponent
        loading={loading}
        setTrackingData={setTrackingData}
        trackingData={trackingData}
        orderDetails={orderDetails}
        biddingDetails={biddingDetails}
        orderDetailsArray={orderDetailsArray}
        activeButton={activeButton}
        setActiveButton={setActiveButton}
        deliveryTime={deliveryTime}
        setDeliveryTime={setDeliveryTime}
        shippingBy={shippingBy}
        setShippingBy={setShippingBy}
        trackingNo={trackingNo}
        setTrackingNo={setTrackingNo}
        showModal={showModal}
        setShowModal={setShowModal}
        cancelOrderModal={cancelOrderModal}
        setCancelOrderModal={setCancelOrderModal}
        showShipModal={showShipModal}
        setShowShipModal={setShowShipModal}
        shippingStatusModal={shippingStatusModal}
        setShippingStatusModal={setShippingStatusModal}
        prefiledData={prefiledData}
        setPrefiledData={setPrefiledData}
        viewDetails={viewDetails}
        setViewDetails={setViewDetails}
        prefiledShipData={prefiledShipData}
        setPrefiledShipData={setPrefiledShipData}
        handleOpenModal={handleOpenModal}
        handleCloseModal={handleCloseModal}
        handleOpenShipModal={handleOpenShipModal}
        handleCloseShipModal={handleCloseShipModal}
        handleOpenCancelOrderModal={handleOpenCancelOrderModal}
        handleOpenShipStatus={handleOpenShipStatus}
        handleCloseCancelOrderModal={handleCloseCancelOrderModal}
        handleShipStatusModal={handleShipStatusModal}
        handleAddAddress={handleAddAddress}
        handleAddTrackingAddres={handleAddTrackingAddres}
        handleStatusUpdate={handleStatusUpdate}
        handleTrackingStatusUpdate={handleTrackingStatusUpdate}
        handleViewDetails={handleViewDetails}
        setDeliveryStatusForm={setDeliveryStatusForm}
        deliverStatusForm={deliverStatusForm}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
        editShipping={editShipping}
        setEditShipping={setEditShipping}
        handleConfirmDelivery={handleConfirmDelivery}
        setCancelStatus={setCancelStatus}
        cancelStatus={cancelStatus}
        setProductClickDetail={setProductClickDetail}
        productClickDetail={productClickDetail}
        trackingDetailModal={trackingDetailModal}
        setTrackingDetailModal={setTrackingDetailModal}
        handleCloseTrackingModal={handleCloseTrackingModal}
        setProductTrackingForm={setProductTrackingForm}
        productTrackingForm={productTrackingForm}
        setErrorMessageTracking={setErrorMessageTracking}
        errorMessageTracking={errorMessageTracking}
        handleCheckShipping={handleCheckShipping}
        trackingAlreadyData={trackingAlreadyData}
      />
      <Footer />
    </div>
  );
};

export default CustomerOrders;
